export const calculateCompoundInterest = ({
  initial,
  monthly,
  rate,
  years,
}) => {
  const safeInitial = parseFloat(initial) || 0;
  const safeMonthly = parseFloat(monthly) || 0;
  const safeRate = parseFloat(rate) || 0;
  const safeYears = parseFloat(years) || 0;
  const totalMonths = Math.max(Math.round(safeYears * 12), 0);
  const monthlyRate = Math.pow(1 + safeRate / 100, 1 / 12) - 1;

  const starting = parseFloat((safeInitial || 0).toFixed(2));
  const data = [{ year: 0, total: starting }];
  const noInterestData = [{ year: 0, total: starting }];
  let total = safeInitial;
  let noInterestTotal = safeInitial;

  for (let i = 0; i < totalMonths; i++) {
    total += total * monthlyRate;
    total += safeMonthly;

    noInterestTotal += safeMonthly;

    const isYearEnd = (i + 1) % 12 === 0;
    const isFinalMonth = i === totalMonths - 1;

    if (isYearEnd || isFinalMonth) {
      const yearPoint = parseFloat(((i + 1) / 12).toFixed(2));
      data.push({ year: yearPoint, total: parseFloat(total.toFixed(2)) });
      noInterestData.push({ year: yearPoint, total: parseFloat(noInterestTotal.toFixed(2)) });
    }
  }

  return {
    chartData: {
      labels: data.map((d) => `${d.year} yr`),
      datasets: [
        {
          label: 'With Interest',
          data: data.map((d) => d.total),
          borderColor: '#1976d2',
          backgroundColor: 'rgba(25, 118, 210, 0.2)',
          tension: 0.3,
          fill: true,
        },
        {
          label: 'No Interest',
          data: noInterestData.map((d) => d.total),
          borderColor: '#9e9e9e',
          backgroundColor: 'rgba(158, 158, 158, 0.1)',
          borderDash: [5, 5],
          tension: 0.3,
          fill: false,
        },
      ],
    },
    summary: {
      withInterest: total,
      withoutInterest: noInterestTotal,
      contributions: safeInitial + safeMonthly * totalMonths,
    },
  };
};
